<script>
import PersonFacilityPicker from "@/components/global/PersonFacilityPicker"
import SitePickerStatic from "@/components/global/SitePickerStatic"
import InstrumentPickerStatic from "@/components/global/InstrumentPickerStatic"
import AssignedDqrTable from "@/components/instrument/AssignedDqrTable"
import DQATable from "@/components/instrument/DQATable"
import DQPRTable from "@/components/instrument/DQPRTable"
import PmrTable from "@/components/instrument/PmrTable.vue"
import CmrTable from "@/components/instrument/CmrTable.vue"
import UpcomingCalibrationsTable from "@/components/instrument/UpcomingCalibrationsTable.vue"
import TablePageFilters from "@/components/instrument/TablePageFilters"
import InstTable from "@/components/instrument/InstTable.vue"
import { mapState } from "vuex"


export default {
  components: {
    SitePickerStatic,
    PersonFacilityPicker,
    InstrumentPickerStatic,
    AssignedDqrTable,
    DQATable,
    DQPRTable,
    PmrTable,
    CmrTable,
    // UpcomingCalibrationsTable,
    TablePageFilters,
    InstTable,
  },
  data() {
    return {
      debug: false,
      dqrInfo: [],
      site: false,
      armsites: {
        id: "armsites",
        label: "Sites",
        defaultLabel: "All Sites",
        placeholder: "All Sites",
        multiple: true,
        value: [],
        options: [],
      },
      facilities: {
        id: "currentFacility",
        defaultLabel: "All Facilites",
        placeholder: "All Facilities",
        siteCode: "",
        readOnly: false,
        value: "",
        options: [],
      },
      instruments: {
        id: "instruments",
        label: "Instruments",
        placeholder: "All Instruments",
        multiple: false,
        value: "",
        options: [],
        retrieveAllOnCreate: false,
      },
      selectedSite: null,
      selectedFacility: null,
      quickFiltered: [],
      showAssignedDqrs: true,
      facilityFilterCode: "",
      selectedInstrument: null,
    }
  },
  computed: {
    ...mapState("instrument", ["personInstruments"]),
    showSites() {
      return this.armsites.options.length > 0
    },
    showFacilities() {
      return this.facilities.options.length > 0
    },
    tableViewFilters() {
      return this.$store.getters["instrument/getTableViewFilters"]
    },
    activeFilter() {
      //Site and facility are selected
      if (this.selectedSite && this.facilityFilterCode) {
        const filter = {
          site: this.selectedSite,
          facility: this.facilityFilterCode,
        }
        // Add instrument to filter if it's selected
        if (this.selectedInstrument) {
          filter.instrument = this.selectedInstrument
        }
        return filter
        // Case 2: Only instrument is selected
      } else if (this.selectedInstrument) {
        return {
          instrument: this.selectedInstrument,
        }
      }
      return null
    },
  },
  watch: {
    personInstruments: {
      handler() {
        this.updateTableData()
      },
      immediate: true,
    },
  },
  created() {
    this.getPersonInstruments()
  },
  mounted() {
    this.updateTableData()
  },
  methods: { 
    updateTableData() {
      const instruments = this.personInstruments
      let filters = instruments

      //Site and facility are selected (with optional instrument)
      if (this.selectedSite && this.facilityFilterCode) {
        filters = instruments.filter(instr => {
          const match = instr.siteCode === this.selectedSite && 
            instr.facilityCode === this.facilityFilterCode
  
          // If instrument is selected, add that to the filter criteria
          if (this.selectedInstrument) {
            return match && instr.instrumentClassCode === this.selectedInstrument
          }
  
          return match
        }) //Only instrument is selected (across all sites and facilities)
      } else if (this.selectedInstrument) {
        filters = instruments.filter(instr => instr.instrumentClassCode === this.selectedInstrument)
      }

      const filterParams = filters.map(instr => ({
        siteCode: instr.siteCode,
        facilityCode: instr.facilityCode,
        instrumentClassCode: instr.instrumentClassCode,
      }))
      this.fetchData(filterParams)
    }
    ,
    fetchData(filters) {

      this.$store.dispatch("instrument/retrieveAssignedDqrInfo", { filters })
        .then(data => {
          this.tableData = data
      
          if (data.length === 0) {
            //console.log("No data found for the selected filters")
          }
        })
        .catch(error => {
          console.error("Error fetching data:", error)
        })
    },
    getPersonInstruments() {
      this.$store.dispatch("instrument/retrieveInstrumentsByPersonId").then((data) => {
        this.createSiteOptions()
      })
    },
    createSiteOptions() {
      const siteCodes = this.$store.getters["instrument/personAvailableSites"]
      const siteSet = new Set(siteCodes)
      let siteOptions = []
      this.$store.dispatch("armint/retrieveAllSites").then((data) => {
        siteOptions = data.reduce((resultArr, itm) => {
          // only show the site if its in site set
          if (siteSet.has(itm.siteCode)) {
            resultArr.push({
              value: itm.siteCode,
              text: `${itm.siteCode}: ${itm.siteName}`,
            })
          }
          return resultArr
        }, [{ value: "", text: "All My Sites" }])

        this.armsites = {
          ...this.armsites,
          options: siteOptions,
          value: siteOptions[0],
        }
      })
    },
    filterBySite(data) {
      // If "All Sites" is selected (empty value)
      if (!data.value) {
        this.selectedSite = null
        // Reset facility selection to "All Facilities" when all sites is selected
        this.facilityFilterCode = null
        this.facilities = {
          ...this.facilities,
          siteCode: "",
          value: "", 
        }
        this.selectedInstrument = null
        this.instruments = Object.assign({}, {
          ...this.instruments,
          facilityCode: "",
          siteCode: "",
          value: "",
          options: [{ 
            instrumentClassCode: "", 
            instrumentName: "All Instruments", 
          }],
        })
        this.$nextTick(() => {
          this.$forceUpdate()
        })
        this.updateTableData()
        return
      }
      this.selectedSite = data.value
      this.facilities = {
        ...this.facilities,
        siteCode: data.value,
      }
    }
    ,
    filterByFacility(data) {
      this.facilityFilterCode = data.value
      this.instruments = {
        ...this.instruments, 
        facilityCode: data.value,
        siteCode: this.facilities.siteCode,
        readOnly : false,
      }
      this.getInstrumentsBySiteAndFacility()
      if (this.selectedSite && this.facilityFilterCode) {
        // console.log("Updating table with filters - Site:", this.selectedSite, "Facility:", this.facilityFilterCode)
        this.updateTableData()
      }
    },
    filterByInstrument(data) {
      this.selectedInstrument = data.value

      if (this.selectedInstrument === "") {
        this.selectedInstrument = null
      }
      // Update tables when instrument is selected, regardless of site/facility selection
      this.updateTableData()
    }

    ,
    getInstrumentsBySiteAndFacility() {
      const insts = []
      this.personInstruments.forEach(itm => {
        if (itm.facilityCode == this.instruments.facilityCode) {
          insts.push(itm.instrumentClassCode)
        }
      })

      const allInsts = new Set(insts)
      const itms = [
        {
          instrumentClassCode: "",
          instrumentName: "All Instruments",
        },
      ]
      allInsts.forEach(itm => {
        itms.push({
          instrumentClassCode: itm,
          instrumentName: itm,
        })
      })
      this.instruments.options = itms
    },
    handleQuickFilter(data) { //recieves sitecode from quickfilter
      if (this.quickFiltered.includes(data)) {
        this.quickFiltered.splice(this.quickFiltered.indexOf(data), 1)
        this.$bvToast.toast(`Instrument ${data.instrumentClassCode} displayed`, {
          title: `Instrument Displayed`,
          autoHideDelay: 5000,
          variant: "success",
        })
      } else {
        this.quickFiltered.push(data)
        this.$bvToast.toast(`Instrument ${data.instrumentClassCode} hidden`, {
          title: `Instrument Hidden`,
          autoHideDelay: 5000,
          variant: "success",
        })
      }
    },
  },
  
}
</script>


<template>
  <div id="timelineView">
    <div class="SearchTopBar PageTopBar">
      <b-form>
        <b-row>
          <b-col v-if="showSites">
            <label class="text-light">Sites</label>
            <SitePickerStatic :value="armsites" @change="filterBySite"/>
          </b-col>
          <b-col>
            <label class="text-light">Facility</label>
            <PersonFacilityPicker v-model="facilities" @change="filterByFacility"/>
          </b-col>
          <b-col>
            <label class="text-light">Instrument</label>
            <InstrumentPickerStatic v-model="instruments" @selectionsChanged="filterByInstrument"/>
          </b-col>
        </b-row>
        <b-row>
          <TablePageFilters />
        </b-row>
      </b-form>
    </div>
    <b-container class="mt-3 gx-0">
      <b-row class="gx-0">
        <b-col v-if="!tableViewFilters.includes('assignedDQRs')" cols="12" class="gx-0">
          <!-- <AssignedDqrTable :site="armsites.value" :facility="facilityFilterCode" :instrument="instruments.value" /> -->
          <!-- <AssignedDqrTable :site="selectedSite"/> -->
          <AssignedDqrTable 
            :site="activeFilter ? activeFilter.site : null"
            :facility="activeFilter ? activeFilter.facility : null"
            :instrument="activeFilter && activeFilter.instrument ? activeFilter.instrument : null" 
          />

        </b-col>
      </b-row>
    </b-container>
    <b-container class="mt-3 gx-0">
      <b-row class="gx-0">
        <b-col v-if="!tableViewFilters.includes('DQPRs')" cols="12" class="gx-0">
          <DQPRTable 
            :site="activeFilter ? activeFilter.site : null"
            :facility="activeFilter ? activeFilter.facility : null" 
            :instrument="activeFilter && activeFilter.instrument ? activeFilter.instrument : null" 
          />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="mt-3 gx-0">
      <b-row class="gx-0">
        <b-col v-if="!tableViewFilters.includes('CMRs')" cols="12" class="gx-0">
          <CmrTable 
            :site="activeFilter ? activeFilter.site : null"
            :facility="activeFilter ? activeFilter.facility : null" 
            :instrument="activeFilter && activeFilter.instrument ? activeFilter.instrument : null" 
          />
        </b-col>
      </b-row>
    </b-container> 
    <b-container class="mt-3 gx-0">
      <b-row class="gx-0">
        <b-col v-if="!tableViewFilters.includes('assignedDQAs')" cols="12" class="gx-0">
          <DQATable 
            :site="activeFilter ? activeFilter.site : null"
            :facility="activeFilter ? activeFilter.facility : null" 
            :instrument="activeFilter && activeFilter.instrument ? activeFilter.instrument : null" 
          />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="mt-3 gx-0">
      <b-row class="gx-0">
        <b-col v-if="!tableViewFilters.includes('PMRs')" cols="12" class="gx-0">
          <PmrTable 
            :site="activeFilter ? activeFilter.site : null"
            :facility="activeFilter ? activeFilter.facility : null" 
            :instrument="activeFilter && activeFilter.instrument ? activeFilter.instrument : null" 
          />
        </b-col>
      </b-row>
    </b-container>
    <!--
    <b-container class="mt-3 gx-0">
      <b-row class="gx-0">
        <b-col v-if="!tableViewFilters.includes('upcomingCalibrations')" cols="12" class="gx-0">
          <UpcomingCalibrationsTable />
        </b-col>
      </b-row>
    </b-container>
  -->
    <b-container class="mt-3 gx-0">
      <b-row class="gx-0">
        <b-col v-if="!tableViewFilters.includes('instTable')" cols="12" class="gx-0">
          <InstTable 
            :site="activeFilter ? activeFilter.site : null"
            :facility="activeFilter ? activeFilter.facility : null" 
            :instrument="activeFilter && activeFilter.instrument ? activeFilter.instrument : null" 
          />

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style>
#timelineView {
  font-weight: bold;
}
</style>
